const DEFAULT_RATING = 4.8;
const AMOUNT_REVIEWS_MIN = 1500;
const AMOUNT_REVIEWS_MAX = 3000;

const RATING_4_8_SHARES: [number, number, number, number, number] = [0.8, 0.12, 0.05, 0.02, 0.01];

export function getRatingsFromRatingAndCount(
  rating: number,
  totalReviews: number
): [number, number, number, number, number] {
  const N = Math.max(0, Math.floor(totalReviews));
  if (N === 0) return [0, 0, 0, 0, 0];

  if (rating >= 4.8 && rating <= 5) {
    const rounded = RATING_4_8_SHARES.map((s) => Math.round(N * s)) as [number, number, number, number, number];
    const diff = N - rounded.reduce((a, b) => a + b, 0);
    if (diff !== 0) rounded[0] += diff;
    return rounded;
  }

  const target = Math.min(5, Math.max(0, rating));
  const weights = [5, 4, 3, 2, 1].map((stars) => Math.max(0, stars - (5 - target)));
  const sumW = weights.reduce((a, b) => a + b, 0);
  if (sumW === 0) return [N, 0, 0, 0, 0];
  const rounded = weights.map((w) => Math.round((N * w) / sumW)) as [number, number, number, number, number];
  const diff = N - rounded.reduce((a, b) => a + b, 0);
  if (diff !== 0 && rounded[0] >= 0) rounded[0] += diff;
  return rounded;
}

export function getDefaultAmountReviews(): number {
  return AMOUNT_REVIEWS_MIN + Math.floor(Math.random() * (AMOUNT_REVIEWS_MAX - AMOUNT_REVIEWS_MIN + 1));
}

export interface DefaultRatingState {
  rating: string;
  amountReviews: string;
  ratings: [number, number, number, number, number];
}

export function getDefaultRatingState(totalReviews?: number): DefaultRatingState {
  const N = totalReviews ?? getDefaultAmountReviews();
  const rating = DEFAULT_RATING;
  return {
    rating: String(rating),
    amountReviews: String(N),
    ratings: getRatingsFromRatingAndCount(rating, N),
  };
}
